import GraphicStorageFields from "../fields";
import { Localize } from "components/service";
import { timeFormat } from "utils/helper-functions";

const graphicStorageColumns = [
  {
    title: <Localize>TABLES.Column_Title_Exhibition</Localize>,
    dataIndex: "exhibition",
    columnIndex: "TITLE",
    sorter: true,
  },
  {
    title: <Localize>TABLES.Column_Title_ConstractionStarts</Localize>,
    dataIndex: "constructionStart_at",
    columnIndex: "CONSTRUCTIONSTART_AT",
    sorter: true,
  },
  {
    title: <Localize>TABLES.Column_Title_ConstractionEnds</Localize>,
    dataIndex: "constructionEnd_at",
    columnIndex: "CONSTRUCTIONEND_AT",
    sorter: true,
  },
  {
    title: <Localize>TABLES.Column_Title_EventStarts</Localize>,
    dataIndex: "start_at",
    columnIndex: "START_AT",
    sorter: true,
  },
  // {
  //   title: <Localize>TABLES.Column_Title_GraphicStorage</Localize>,
  //   dataIndex: "standsCraftTypeCount",
  //   columnIndex: "STANDS_CRAFT_TYPE_COUNT",
  //   // sorter: true,
  //   width: "8%",
  // },
];

const graphicStorageData = (events) => {
  if (!events) {
    return [];
  }

  return events.map((event) => {
    return {
      key: event.id,
      exhibition: <GraphicStorageFields.Link id={event.id} title={event.title} />,
      constructionStart_at: timeFormat(event?.constructionStart_at) ?? (
        <strong>&mdash;</strong>
      ),
      constructionEnd_at: timeFormat(event?.constructionEnd_at) ?? (
        <strong>&mdash;</strong>
      ),
      start_at: timeFormat(event?.start_at) ?? <strong>&mdash;</strong>,
      //TODO: return this column when we have the data after migration 
      // standsCraftTypeCount: (
      //   <GraphicStorageFields.View
      //     id={event.id}
      //     count={event.standsCraftTypeCount}
      //     model={"graphics"}
      //   />
      // ),
    };
  });
};

const GraphicStorageTableHelper = {
  columns: graphicStorageColumns,
  data: graphicStorageData,
};

export default GraphicStorageTableHelper;
